import { useLayoutEffect } from 'react'

export function TrackingFallback() {
    return (
        <noscript><p><img
            aria-hidden={true}
            referrerPolicy="no-referrer-when-downgrade"
            src="https://js-cdn.blockchair.net/f62748d16a48971a7938.php7?idsite=6&amp;rec=1"
            style={{ border: 0 }}
            alt=""
        /></p></noscript>
    )
}

export default function Tracking ()
{
    var _paq = (window as any)._paq = (window as any)._paq || []
    /* tracker methods like "setCustomDimension" should be called before "trackPageView" */

    _paq.push(['setDocumentTitle', document.domain + '/' + document.title])
    _paq.push(['setCookieDomain', '*.privacy.watch'])
    _paq.push(['setDomains', ["*.privacy.watch", "*.privacymarketcap.com","*.pmc.3xpl.net","*.pmc.3xpl.net","*.privacy.markets","*.privacy.store"]])
    _paq.push(['enableCrossDomainLinking'])
    _paq.push(['setDoNotTrack', true])
    _paq.push(['trackPageView'])
    _paq.push(['enableLinkTracking'])
    _paq.push(["trackVisibleContentImpressions"]);
    _paq.push(["disableAlwaysUseSendBeacon"]);

    useLayoutEffect(() =>
    {
        if (window.location.host.includes('localhost') || window.location.host.includes('127.0.0.1')) {
            return
        }

        var u = 'https://js-cdn.blockchair.net'

        _paq.push(['setTrackerUrl', u + '/f62748d16a48971a7938.php7'])
        _paq.push(['setSiteId', '6'])

        var d = document, g = d.createElement('script')
        g.type = 'text/javascript'
        g.async = true
        g.src = u + '/f62748d16a48971a7938.js'
        d.body.appendChild(g)
    }, [])

    return (
        <></>
    )
}